import type { ReactNode } from 'react';
import { TimestampDisplay } from '@/components/ui/timestamp-display';

export function JobTime({ value }: { value: string | null | undefined }) {
  return value ? (
    <TimestampDisplay date={value} />
  ) : (
    <span className="text-gray-500">Not reported</span>
  );
}

export function JobOutcome({ value }: { value: string | null | undefined }) {
  const label = value === 'success' ? 'Success' : value === 'failure' ? 'Failure' : 'No result yet';
  const color =
    value === 'success'
      ? 'bg-green-50 text-green-800'
      : value === 'failure'
        ? 'bg-red-50 text-red-800'
        : 'bg-gray-100 text-gray-700';
  return (
    <span className={`inline-flex rounded-md px-2 py-1 text-xs font-medium ${color}`}>{label}</span>
  );
}

export function JobField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="min-w-0">
      <dt className="text-sm text-gray-500">{label}</dt>
      <dd className="mt-1 text-sm font-medium text-gray-900 break-words">{children}</dd>
    </div>
  );
}

export function formatDuration(startedAt: string | null, finishedAt: string | null): string | null {
  if (!startedAt || !finishedAt) return null;
  const duration = Date.parse(finishedAt) - Date.parse(startedAt);
  if (!Number.isFinite(duration) || duration < 0) return null;
  if (duration < 1_000) return `${duration} ms`;
  if (duration < 60_000) return `${(duration / 1_000).toFixed(1)} s`;
  const minutes = Math.floor(duration / 60_000);
  const seconds = Math.floor((duration % 60_000) / 1_000);
  return `${minutes} min ${seconds} s`;
}
